export default "__VITE_ASSET__Cku2GdaT__"